/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Tc, $, SCS) {
	'use strict';

	/**
	 * Product Comparator
	 *
	 * @author taaatra1
	 * @namespace Tc.Module
	 * @class ProductComparator
	 * @extends Tc.Module
	 */
	Tc.Module.ProductComparator = Tc.Module.extend({
		on: function(callback) {
			var mod = this,
				$ctx = mod.$ctx;

			mod.productComparisonCookie = 'SCSMiniComparedProductList';
			mod.productComparisonList = SCS.productComparisonList || [];
			mod.maxElementToCompare = 3;
			mod.addToComparisonURL = '/portalshop/de/Comparison/AddProduct/';
			mod.removeFromComparisonURL = '/portalshop/de/Comparison/RemoveProduct/';

			$ctx.find('.scsh-compare-info').on('click', function () {
				$ctx.trigger('scsh-flyout-open');
			});

			mod.updateProductComparator();

			mod.updateSCSNamespace();

			callback();
		},

		updateSCSNamespace : function() {
			var mod = this;
			SCS.comparisonProduct = function(a) { mod.comparisonProduct(a); };
			SCS.readProductComparisonCookie = function(a) { mod.readProductComparisonCookie(a); };
			SCS.addToProductComparisonList = function(productId, productName, miniImg, productType) { mod.comparisonProduct(productId, productName, miniImg, productType); };
			SCS.removeFromProductComparisonList = function(a) { mod.removeFromProductComparisonList(a); };
			SCS.getProductComparisonListIndex = function(a) { mod.getProductComparisonListIndex(a); };
			SCS.updateProductComparator = function(a) { mod.updateProductComparator(a); };
			SCS.compareDeviceDetailPage = function(a) { mod.compareDeviceDetailPage(a); };
			SCS.addToComparison = function(event, productId, productName, productImage, productType) { mod.addToComparison(event, productId, productName, productImage, productType); };
			SCS.removeFromComparison = function(event,productId) { mod.removeFromComparison(event,productId); };
			SCS.displayComparisonError = function(a) { mod.displayComparisonError(a); };
		},

		comparisonProduct : function (productId, productName, miniImg, productType) {
			if (!productType) {
				productType = 'mobile';
			}

			return {
				Id: productId,
				Name: productName,
				Image: miniImg,
				ProductType: productType
			};
		},

		readProductComparisonCookie : function() {
			var mod = this;
			if ($.cookie(mod.productComparisonCookie)) {
				try {
					mod.productComparisonList = $.parseJSON($.cookie(mod.productComparisonCookie));
				} catch(e) {
					mod.productComparisonList = [];
					window.debug.log('Tc.Module.ProductComparator > cannot read cookie ' + mod.productComparisonCookie, e);
				}
			} else {
				mod.productComparisonList = [];
			}
		},

		addToProductComparisonList : function(productId, productName, miniImg, productType) {
			var mod = this;
			var product = mod.comparisonProduct(productId, productName, miniImg, productType);
			mod.productComparisonList.push(product);
		},

		removeFromProductComparisonList : function(productId) {
			var mod = this,
				idx = mod.getProductComparisonListIndex(productId);

			if (idx > -1) {
				mod.productComparisonList.splice(idx, 1);
			}
		},

		getProductComparisonListIndex : function(productId) {
			var mod = this;
			for (var i = 0; i < mod.productComparisonList.length; i += 1) {
				if (mod.productComparisonList[i].Id === productId) {
					return i;
				}
			}
			return -1;
		},

		updateProductComparator : function() {
			var mod = this,
				$ctx = mod.$ctx;

			$ctx.hide();
			$ctx.find('ul').html('');
			mod.enableCompare(true);

			mod.readProductComparisonCookie();

			var list = mod.productComparisonList;

			var handler = function(event) {
				var $icon = $(this);
				var id = $icon.data('product-id');

				$ctx.trigger('scsh-flyout-close', {});
				mod.removeFromComparison(event, id);
				var n = list.length;
				$ctx.find('.scsh-compare-count').html(n);
				if (n === 0) {
					mod.enableCompare(false);
				}
				// uncheck Comparison checkbox on Product Detail page
				$('#chkCompare' + id).attr('checked', false).trigger('updateState');
			};

			for (var i = 0; i < list.length; i += 1) {
				var product = list[i];
				var img = $('<img/>').attr('src', product.Image);
				var div = $('<div/>').addClass('scsh-compare-name').append(product.Name);
				var icon = $('<div/>').addClass('scsh-compare-delete-icon').data('product-id', product.Id).click(handler);
				var li = $('<li/>').addClass('scsh-compare-product').append(img).append(icon).append(div);
				$ctx.find('ul').append(li);
			}

			$ctx.find('.scsh-compare-count').html(list.length); // mod.maxElementToCompare
			if (list.length === 0) {
				mod.enableCompare(false);
			}
			$ctx.show();
		},

		enableCompare : function(should) {
			var mod = this,
				$ctx = mod.$ctx;

			$ctx.toggleClass('scsh-empty', !should);
			$ctx.find('.modFlatButton a').toggleClass('disabled', !should);
		},

		compareDeviceDetailPage : function(event) {
			var mod = this;
			var productId = $(event.target).attr('data-product-id');
			var productName = $(event.target).attr('data-product-name');
			var productImage = $(event.target).attr('data-mini-image');
			var productType = $(event.target).attr('data-product-type');
			if (mod.getProductComparisonListIndex(productId) === -1) {
				mod.addToComparison(event, productId, productName, productImage, productType);
			} else {
				mod.removeFromComparison(event, productId);
			}
		},

		addToComparison : function(event, productId, productName, productImage, productType) {
			var mod = this;
			var $this = $(event.target);
			//if comparison is already full
			var wrongProductType = (mod.productComparisonList.length && mod.productComparisonList[0].ProductType !== productType);

			if (mod.productComparisonList.length >= mod.maxElementToCompare || wrongProductType) {
				var compareFull = (productType === 'mobile') ? mod.$ctx.data('productComparatorFull') : mod.$ctx.data('productComparatorFullTablets');
				var qtipText = (!wrongProductType) ? compareFull : mod.$ctx.data('productComparatorWrongType');
				$this.attr('checked', false).trigger('updateState');
				$this.qtip({
					content : '<div class="sc-richtext-failure">' + qtipText + '</div>',
					style : {
						classes : 'ui-tooltip-ecommerce',
						width : 240
					},
					show : {
						event : 'click',
						effect : function() {
							$(this).fadeIn(1000);
						}
					},
					hide : {
						event : false,
						inactive : 3500,
						effect : function() {
							$(this).fadeOut(1000);
						}
					},
					events : {
						hidden : function(event, api) {
							api.destroy();
						}
					}
				});

				$this.qtip('show');
				return;
			}

			mod.addToProductComparisonList(productId, productName, productImage, productType);
			$.cookie(mod.productComparisonCookie, window.JSON.stringify(mod.productComparisonList), { path: '/' });

			mod.updateProductComparator();
		},

		removeFromComparison : function(event,productId) {
			var mod = this;
			mod.removeFromProductComparisonList(productId);

			if (mod.productComparisonList.length) {
				$.cookie(mod.productComparisonCookie, window.JSON.stringify(mod.productComparisonList), { path: '/' });
			} else {
				$.cookie(mod.productComparisonCookie, null, { path: '/' });
			}
			mod.updateProductComparator();
		},

		displayComparisonError : function(xhr) {
			SCS.portal.showError('error', xhr.responseText);
		}
	});
}(window.Tc, window.scsHeaderJQuery, window.SCS = window.SCS || {}));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/header/clientlibs/responsive/js/modules/Tc.Module.ProductComparator.js
// module id = 363
// module chunks = 0